import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/oakland-dinners")({
  component: () => <Navigate to="/cities/oakland" replace />,
});
